import { createAction, props } from '@ngrx/store';
import {GlobalSearchResultItem} from "../../models/global-search.model";

export const executeGlobalSearch = createAction(
  '[GlobalSearch Component] Search',
  props<{ searchTerm: string }>()
);

export const executeGlobalSearchSuccess = createAction(
  '[GlobalSearch DataAccess] Execute GlobalSearch Success',
  props<{ globalSearchResults: GlobalSearchResultItem[] }>()

);

export const executeGlobalSearchFailure = createAction(
  '[GlobalSearch DataAccess] Execute GlobalSearch Failure',
  props<{ error: any }>()
);


